import Card from '@zenbusiness/zui/Card';
import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const ItemsStack = superstyled({
  tag: Stack,
  name: 'AssistanceSection',
  slot: 'ItemsStack',
  styles: ({ theme }) => ({
    flexDirection: 'column',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  }),
});

export const ItemLink = superstyled({
  tag: Link,
  name: 'AssistanceSection',
  slot: 'ItemLink',
  styles: {
    textDecoration: 'none',
    flex: 1,
  },
});

export const ItemCard = superstyled({
  tag: Card,
  name: 'AssistanceSection',
  slot: 'ItemCard',
  styles: ({ theme }) => ({
    padding: theme.spacing(2),
  }),
});

export const ItemHeaderStack = superstyled({
  tag: Stack,
  name: 'AssistanceSection',
  slot: 'ItemHeaderStack',
  styles: {
    marginBottom: '0.75rem',
  },
});
